module.exports = __webpack_public_path__ + "img/wx-share-2.1ee5d2f5.jpg";